export const useYCaptcha = async () => {
  return new Promise((resolve, reject) => {
    const {
      public: { yCaptchaKey },
    } = useRuntimeConfig();

    useHead({
      script: [
        {
          src: 'https://smartcaptcha.yandexcloud.net/captcha.js',
          defer: true,
          onload,
          onerror,
        },
      ],
    });

    function onload() {
      if (window.smartCaptcha) {
        resolve({
          captchaInstance: window.smartCaptcha,
          captchaKey: yCaptchaKey,
        });
      } else {
        reject('"window.smartCaptcha" not found');
      }
    }
    function onerror() {
      reject('smartCaptcha load error');
    }
  });
};
